<div class="tab-container" *ngIf="refund; ">
    
    Клиент <b>{{refund.buypoint}}</b> <button mat-flat-button (click)="openClientDialog()" style="margin-left: 1em;"
        color="primary">Изменить</button><br>
    <span *ngIf="refund.firm">Организация <b>{{refund.firm}}</b> </span>
    <span *ngIf="refund.orderId && order && order.number"><br>Возврат по заказу <b>{{order.number}}</b> <a
            [routerLink]="['/orderinfo', refund.orderId ]"><mat-icon class="order_link"
                color="primary">link</mat-icon></a> </span>
    <br />
    <span class="label">Сумма</span><span class="air currency">
        {{refund.summa | currency:'RUB':'symbol':'1.2-2':'ru'}}</span>
    <br>
    <mat-form-field class="extra">
        <mat-label>Комментарий</mat-label>
        <input matInput name="comment" [(ngModel)]="refund.deliveryComment" (ngModelChange)="updChanges = true">
    </mat-form-field>

    <br>
    <mat-form-field>
        <mat-label>Дата</mat-label>

        <input matInput [matDatepicker]="picker" name="actualDate" [(ngModel)]="refund.dateDelivery"
            (ngModelChange)="updChanges = true" [min]="minDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker class="B"></mat-datepicker>

    </mat-form-field>
    <button mat-icon-button *ngIf="refund.dateDelivery" (click)="refund.dateDelivery=undefined; updChanges = true">
        <mat-icon>clear</mat-icon>
    </button>

    <br><br>
    <button style="margin-right: 8px;" mat-flat-button color="accent" *ngIf="updChanges"
        (click)="save()">сохранить</button>


    <div style="margin-top: 12px;">
        <div *ngFor="let item of refund.items" class="row">
            <span class="rests-item"> {{item.good}}</span>
            <div class="break"></div> <!-- break -->
            <span class="label">кол-во</span>
            <span class="air amount">{{item.amount}} шт,</span>

            <span class="label">цена</span>
            <span class="air currency">{{item.price | currency:'RUB':'symbol':'1.2-2':'ru'}},</span>


            <span class="label">сумма</span>
            <span class="air currency">{{item.summa | currency:'RUB':'symbol':'1.2-2':'ru'}}</span>
            <span *ngIf="item.promotionCode">
                <span class="label">код акции</span>
                <span class="air warn">{{item.promotionCode }}</span>
            </span>
            <span class="spacer"></span>
            <span>
                <button mat-icon-button color="accent" (click)="deleteItem(item.goodId)">
                    <mat-icon>delete</mat-icon>
                </button>
            </span>
            <span class="caption">
                <button mat-icon-button color="primary" (click)="clickOnItem(item)" class="caption">
                    <mat-icon class=" caption">edit</mat-icon>
                </button>
            </span>
        </div>
    </div>

</div>